export const WHATSAPP_NUMBER = "918610554890"; // WhatsApp business number without '+'

/**
 * Builds encoded WhatsApp URL for single product bulk/wholesale inquiry
 */
export const generateSingleProductWholesaleUrl = ({
  productName,
  variant = "",
  quantity = 50,
  buyerName = "",
  phoneNumber = "",
  buyerCity = "",
  notes = "",
}) => {
  const qtyNum = Number(quantity) || 1;

  const message = `*BULK / WHOLESALE INQUIRY*
----------------------------------------
*Product:* ${productName}
${variant ? `*Variant / Size:* ${variant}\n` : ""}*Quantity:* ${qtyNum} units

*BUYER DETAILS:*
- Name / Business: ${buyerName || "Not specified"}
${phoneNumber ? `- Phone / WhatsApp: ${phoneNumber}\n` : ""}- Location: ${buyerCity || "Not specified"}
${notes ? `- Notes / Requirements: ${notes}\n` : ""}----------------------------------------
_Please share your best wholesale quote, available discounts, and delivery timeline._`;

  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
};

/**
 * Builds encoded WhatsApp URL for multiple products bulk/wholesale inquiry
 */
export const generateMultiProductWholesaleUrl = ({
  items = [], // Array of { name, product_name, variant, qty }
  buyerName = "",
  phoneNumber = "",
  buyerCity = "",
  notes = "",
}) => {
  const totalUnits = items.reduce((sum, item) => sum + Number(item.qty || 1), 0);

  const productListText = items
    .map((item, index) => {
      const name = item.name || item.product_name || "Product";
      const variantStr = item.variant ? `\n   - Variant: ${item.variant}` : "";
      const qty = Number(item.qty || 1);

      return `${index + 1}. *${name}*${variantStr}
   - Quantity: ${qty} units`;
    })
    .join("\n\n");

  const message = `*BULK / WHOLESALE INQUIRY (MULTIPLE ITEMS)*
----------------------------------------
*SELECTED PRODUCTS:*

${productListText}

----------------------------------------
*SUMMARY:*
- Total Products: ${items.length}
- Total Units: ${totalUnits} units

*BUYER DETAILS:*
- Name / Business: ${buyerName || "Not specified"}
${phoneNumber ? `- Phone / WhatsApp: ${phoneNumber}\n` : ""}- Location: ${buyerCity || "Not specified"}
${notes ? `- Notes / Requirements: ${notes}\n` : ""}----------------------------------------
_Please share your best wholesale quote, available discounts, and delivery timeline._`;

  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
};
